<template>
  <div class="block-wrap card text-start">
    <div class="card-body">
      <h5 class="card-title mobile-body">{{ news.title }}</h5>
      <p class="card-text news-content mobile-small" v-html="news.content"></p>
      <div class="d-flex justify-content-between">
        <div v-if="news.link_text.length > 0 && news.link.length > 0">
          <a :href="news.link" class="card-link d-flex align-items-center"
            >{{ news.link_text
            }}<img class="link ms-1" :src="linkArrow" :alt="news.link_text"
          /></a>
        </div>
        <div v-else style="opacity: 0">
          <a class="card-link d-flex align-items-center"
            >無連結<img
              class="link ms-1"
              :src="linkArrow"
              :alt="news.link_text"
          /></a>
        </div>

        <div class="date old-small align-self-center">
          {{ formatDate(news.display_at) }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs';
import linkArrow from '@/assets/img/link_arrow_w.png';
import OverlayScrollbars from 'overlayscrollbars/js/OverlayScrollbars.min';

export default {
  name: 'NewsArticle',
  props: {
    news: { type: Object, required: false },
  },
  data() {
    return {
      linkArrow,
    };
  },
  methods: {
    formatDate(dateString) {
      const date = dayjs(dateString);
      // Then specify how you want your dates to be formatted
      return date.format('YYYY/MM/DD');
    },
  },
  mounted() {
    const settings = {
      className: 'os-theme-dark',
      sizeAutoCapable: true,
      paddingAbsolute: true,
      scrollbars: {
        clickScrolling: true,
        visibility: 'auto',
      },
    };

    settings.scrollbars.autoHide = 'leave';
    settings.scrollbars.autoHideDelay = 200;
    OverlayScrollbars(document.querySelectorAll('.news-content'), settings);
  },
};
</script>

<style lang="stylus" scoped>
.block-wrap
  background: #FFFFFF;
  border: 1px solid #BCB8B1;
  border-radius: 20px;
  margin-right: calc((var(--bs-gutter-x) / 2));
  margin-left: calc((var(--bs-gutter-x) / 2));
  white-space: normal;

  .card-body
    padding: 24px;

  .card-text
    border-top: 1px solid $monoc4;
    border-bottom: 1px solid $monoc4;
    padding: 16px 0 32px 0;
    margin: 16px 0;
    // min-height: 320px;
    height: 340px;
    overflow-y: scroll;
    overflow-x: hidden;

  .card-link
    background-color: $monoc4;
    color: $monoc1;
    border-radius: 100px;
    padding: 10px;
    text-decoration: none;

    img
      width: 27px;

  .date
    color: $monoc2;
</style>
